import reportApi from "@/api/reportApi"
import UseSearchString from "@/composables/UseSearchString"

export default {
  namespaced: true,
  state: {
    housesTree: [
      {
        name: 'Россия',
        id: 'country',
        links: [],
        elements: undefined
      }
    ],
    reportData: [],
    filterReportData: '',
    isCountHousesLoading: false,
    isReportCreating: false,
    countHouses: undefined,
    xlsReportLink: {
      full: undefined,
      summary: undefined
    }
  },
  getters: {
    getReportData(state, getters, rootState) {
      return state.reportData
        .map(category => ({
            ...category,
            elements: category.elements.map(el => ({
              elementId: el.id,
              elementName: el.name,
              value: el.sum,
              unit: rootState.elements.common.unitValues[el.unit]
            }))
          })
        )
    },

    getFilteredReportData(state, getters) {
      const searchInput = state.filterReportData
      return getters.getReportData.reduce((accumulator, category) =>
        [
          ...accumulator,
          ...category.elements
            .filter(el => el.elementName.toLowerCase().includes(searchInput.toLowerCase()))
            .map(el => ({
              ...el, elementName: `${category.name} -> ${UseSearchString.fillSearchResult(el.elementName, searchInput)}`
            }))
        ], [])
    }
  },
  mutations: {
    addLoadedChildren(state, {children, map}) {
      let housesTreePart = state.housesTree
      let AllChildren = []
      if (!Array.isArray(children)) {
        AllChildren = Object.keys(children)
          .filter(i => children[i].length > 0)
          .reduce((acc, i) => [
            ...acc,
            ...children[i].map(item => ({...item, id: `${i}_${item.id}`}))
          ], [])
      } else {
        AllChildren = children
      }

      map = map.split('-').filter(i => i)
      map.forEach((i, index) => {
        housesTreePart = housesTreePart.find(el => String(el.id) === i)
        if (index !== map.length - 1) {
          housesTreePart = housesTreePart.elements
        }
      })
      housesTreePart.elements = AllChildren
    },

    setCountHousesLoading(state, payload) {
      state.isCountHousesLoading = payload
    },

    setReportCreatingStatus(state, payload) {
      state.isReportCreating = payload
    },

    setReportData(state, payload) {
      state.reportData = payload
    },

    setCountHouses(state, payload) {
      state.countHouses = payload
    },

    setFilterReportData(state, payload) {
      state.filterReportData = payload
    },

    setGeneralReportLinks(state, payload) {
      state.housesTree[0].links = [
        ...state.housesTree[0].links,
        {
          action: 'GET',
          href: payload.find(i => i.rel === 'regions').href,
          rel: 'children',
        },
        {
          action: 'GET',
          href: payload.find(i => i.rel === 'passports_report').href,
          rel: 'report',
        },
        {
          action: 'GET',
          href: payload.find(i => i.rel === 'passports_number').href,
          rel: 'num_passports',
        },
        {
          action: 'GET',
          href: payload.find(i => i.rel === 'passports_report_xls').href,
          rel: 'report_xls',
        },
        {
          action: 'GET',
          href: payload.find(i => i.rel === 'passports_report_detail_xls').href,
          rel: 'report_detail_xls',
        }
      ]
    },

    setXlsReportLinks(state, {full, summary}) {
      state.xlsReportLink = {full, summary}
    },

    clearReportState(state) {
      state.housesTree[0].elements = undefined
      state.reportData = []
      state.filterReportData = ''
      state.isCountHousesLoading = false
      state.isReportCreating = false
      state.countHouses = undefined
      state.xlsReportLink = {
        full: undefined,
        summary: undefined
      }
    }

  },
  actions: {
    loadChildren({commit}, {link, map}) {
      return reportApi.loadChildren(link)
        .then(response => commit('addLoadedChildren', {children: response, map}))
    },

    getCountHouses({commit}, link) {
      commit('setCountHousesLoading', true)
      return reportApi.getCountHouses(link)
        .then(response => {
          commit('setCountHouses', response.num)
          commit('setCountHousesLoading', false)
        })
    },

    createReport({commit, rootState, dispatch}, link) {
      commit('setReportCreatingStatus', true)
      return reportApi.createReport(link)
        .then(response => {
          if (rootState.elements.common.unitValues.length === 0) {
            dispatch('elements/loadUnitValues', undefined, {root: true})
              .then(() => {
                commit('setReportData', response)
                commit('setReportCreatingStatus', false)
              })
          } else {
            commit('setReportData', response)
            commit('setReportCreatingStatus', false)
          }

        })
    },

    loadSummaryReport({state}) {
      return reportApi.loadReport(state.xlsReportLink.summary)
    },

    loadFullReport({state}) {
      return reportApi.loadReport(state.xlsReportLink.full)
    }
  }
}
